<template>
  <div class="component-avatar">
    <div class="avatar">
      <img :src="src" alt title>
    </div>
  </div>
</template>


<script>
import md5 from 'md5'

export default {
  props: {
    size: {default: '200', type: String},
    email: {default: '', type: String} // tkj@tkjaergaard.dk
  },
  computed: {
    style () {
      return {
        width: this.size + 'px',
        height: this.size + 'px'
      }
    },
    src () {
      return '//www.gravatar.com/avatar/' + md5(this.email) + '?s=' + this.size
    }
  }
}
</script>


<style lang="scss" scoped>
.component-avatar {
  display: flex;

  .avatar {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Avatar.vue?571a6e26